/**
 * Sticky add to cart and navigation menu.
 */
const ATCBarVisibilityChecker = {
  init() {
    this.stickyBar = document.querySelector('.StickyProductBar');
    this.navBar = document.querySelector('.StickyNavBar');
    this.zopimElements = [];

    // Mobile bars
    this.mobileATCBar = document.querySelector('.MobileATCBar');
    this.mobSizeMenu = document.querySelector('.MABarSelectMenu');

    this.linkATCButtons();
    this.attachScrollListeners();
    this.makeLinkScrollingSmooth();
  },

  makeLinkScrollingSmooth() {
    const links = document.querySelectorAll('.StickyNavBar__Link');
    links.forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
        });
      });
    });
  },

  linkATCButtons() {
    const mainATCBtn = document.querySelector('.MattressProductATCBtn__Btn');
    const stickyBtn = document.querySelector('.StickyATCBar__ATCBtn');
    const mobileBtn = document.querySelector('.MobileATCBar__ATCBtn');

    stickyBtn.addEventListener('click', () => {
      mainATCBtn.click();
    });

    mobileBtn.addEventListener('click', () => {
      mainATCBtn.click();
    });
  },

  attachScrollListeners() {
    this.updateBarVisibilityOnScroll();
    this.highlightActiveLinkOnScroll();
  },

  updateBarVisibilityOnScroll() {
    const productCard = document.querySelector('.MattressProductATCBtn');
    const topOfBtn = productCard.offsetTop;
    const btnHeight = productCard.offsetHeight;

    // An offset that can be customized
    const scrollOffsetBeforeReveal = 150;

    let lastScrollTop = 0;
    window.addEventListener('scroll', NUtils.debounce(() => {
      // Reveal the sticky add to cart bar after scrolling a little past the product form
      if (
        window.scrollY > (topOfBtn + btnHeight + scrollOffsetBeforeReveal)
      ){
        this.showATCBar();
      }
      else {
        this.hideATCBar();
      }

      // Override the above and hide the sticky add to cart when scrolling up
      if (window.scrollY < lastScrollTop) {
        // Hide only the top sticky bar (not the mobile atc bar at the bottom)
        this.stickyBar.classList.add('StickyProductBar--hidden');
      }

      // Remember the scrollY for next time
      // lastScrollTop = window.scrollY <= 0 ? 0 : window.scrollY;
    }, 50));
  },

  showATCBar() {
    this.stickyBar.classList.remove('StickyProductBar--hidden');
    this.mobileATCBar.classList.remove('MobileATCBar--hidden');
    document.body.classList.add('sticky-atc-enabled');
    this.pushChatBtnUpOnMobile();
  },

  hideATCBar() {
    this.stickyBar.classList.add('StickyProductBar--hidden');
    this.mobileATCBar.classList.add('MobileATCBar--hidden');
    document.body.classList.remove('sticky-atc-enabled');
    this.pushChatBtnDownOnMobile();
  },

  hideATCBarOnlyForDesktop() {
  },

  /**
   * Pushes zopim chat up (mobile only).
   * Note that zopim shows a different chat btn when you start the page on mobile
   * that is not flush to the bottom of the page like the chat window on desktop.
   * So, if you resize the window down from desktop, it will look different.
   */
  pushChatBtnUpOnMobile() {
    if (this.zopimElements.length <= 0) {
      // There are several elements, the window, the button, the unread badge
      this.zopimElements = document.querySelectorAll('.zopim[data-test-id]');
    }
    this.zopimElements.forEach(el => el.classList.add('zopim--pushedUpOnMobile'));
  },

  /**
   * Pushes zopim chat down (mobile only)
   */
  pushChatBtnDownOnMobile() {
    if (this.zopimElements.length <= 0) {
      this.zopimElements = document.querySelectorAll('.zopim[data-test-id]');
    }
    this.zopimElements.forEach(el => el.classList.remove('zopim--pushedUpOnMobile'));
  },

  /**
   * Highlight the link when scrolled to within the section it represents.
   */
  highlightActiveLinkOnScroll() {
    const links = document.querySelectorAll('.StickyNavBar__Link');

    window.addEventListener('scroll', NUtils.debounce(() => {

      links.forEach(link => {
        // Get the hash target that the link represents
        const target =
          document.querySelector(link.getAttribute('href'));

        // Attempt to get the target's matching section for its height later
        let matchingSection;
        if (target) {
          matchingSection = target.closest('.shopify-section');
        }

        if (!target || !matchingSection) {
          return;
        }

        // A hardcoded offset that allows for the highlight to trigger higher
        // up than normal.
        const highlightOffset = -50;

        // If scroll position is within a section, highlight its link
        const topOfTarget = target.offsetTop + highlightOffset;
        const sectionHeight = matchingSection.offsetHeight;
        const scrollPos = window.scrollY
        if (
          scrollPos > topOfTarget
          && scrollPos <= (topOfTarget + sectionHeight)
        ){
          // Remove all other active css classes on links
          links.forEach(l => l.classList.remove('StickyNavBar__Link--active'));

          link.classList.add('StickyNavBar__Link--active');

          // On mobile, see if you may have to scroll it into view
          if (link.offsetLeft > 0) {
            this.navBar.scrollTo({
              top: 0,
              left: (link.offsetLeft - 15),
              behavior: 'smooth'
            });
          }
        }
      });
    }, 50));
  },
};
ATCBarVisibilityChecker.init();

window.StickyATCBarSelectDebugObj = {
  iCount: 0,
};
class StickyATCBarSelect extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;

    // Debug info
    window.StickyATCBarSelectDebugObj.iCount++;
    this.instanceIndex = window.StickyATCBarSelectDebugObj.iCount;
    if (this.instanceIndex === 2) {
      console.warn('sticky-atc-bar-select: constructor called more than once');
    }
  }

  connectedCallback() {
    if (this.isConnected) {
      this.cacheElements();
    }

    if (this.isConnected && !this.initialized) {
      this.initialized = true;
      this.syncToCurrentVariant();
      this.attachListeners();
    }
  }

  disconnectedCallback() {
    if (!this.isConnected && this.initialized) {
      this.initialized = false;
      this.detachListeners();
    }
  }
  
  cacheElements() {
    this.menuClickHandler = this.menuClickHandler.bind(this);
    this.syncToCurrentVariant = this.syncToCurrentVariant.bind(this);

    this.selector = this.querySelector('.ATCBarSelect__Selector');
    this.menu = this.querySelector('.ATCBarSelect__Menu');
    this.sizeBtns = this.querySelectorAll('.ATCBarSelect__OptionBtn');
  }

  attachListeners() {
    document.addEventListener('click', this.menuClickHandler);
    document.addEventListener('state:option-changed', this.syncToCurrentVariant);
  }

  detachListeners() {
    document.removeEventListener('click', this.menuClickHandler);
    document.removeEventListener('state:option-changed', this.syncToCurrentVariant);
  }

  /**
   * Sync to the current selected variant. Split king is a special 'fake' size
   * that is internally selected as the Twin XL mattress in NolahPDPState, but
   * with a flag pseudoSplitKingSelected set to true so we can know to add two
   * Twin XL mattresses when needed.
   */
  syncToCurrentVariant(e) {
    console.debug('sticky-atc-bar-select: syncToCurrentVariant', this.isConnected, this.instanceIndex);
    const currentSize = window.NolahPDPState.getOptionByName('Size');

    // Escape quotations for querySelector strings with //"
    const escapedValue = currentSize.replace('"', '\\"');

    const selectedBtn =
      this.querySelector(`.ATCBarSelect__OptionBtn[data-value="${escapedValue}"]`);
    this.updateSelfPassively(selectedBtn);

    // If the product JSON changed, we will want to update the price labels
    // in the size select.
    if (typeof e !== 'undefined' && e.detail && e.detail.productJSONChanged) {
      this.syncPriceLabelsToState();
    }
  }

  /**
   * Responsible for opening/closing the menu and selecting sizes
   */
  menuClickHandler(e) {
    if (e.target.matches('.ATCBarSelect__Selector')) {
      this.toggleMenu();
    } else if(e.target.matches('.ATCBarSelect__OptionBtn')) {
      this.select(e.target);
    } else {
      this.closeMenu();
    }
  }

  /**
   * Updates the selected button, and changes the global state object,
   * triggering the state:option-changed event.
   */
  select(button) {
    // Set new selected button
    this.updateSelfPassively(button);

    // Clear any addons (since a new size was selected)
    window.NolahPDPState.clearAddons();

    // Update state and selector
    window.NolahPDPState.setSizeAndResetFirmness(button.dataset.value);

    this.closeMenu();
  }

  /**
   * Does not update state, and as a result, also does not trigger
   * the state:option-changed event. Meant to be used to update its select
   * passively in response to the variant changing due to other components.
   */
  updateSelfPassively(button) {
    if (!button) {
      this.logErrorWithContext('sticky-atc-bar-select: updateSelfPassively without arg')
      return;
    }

    // Set new selected button
    this.sizeBtns.forEach(b => b.classList.remove('ATCBarSelect__OptionBtn--selected'))
    button.classList.add('ATCBarSelect__OptionBtn--selected');

    // Update selector
    this.selector.innerHTML = button.innerHTML;
  }

  openMenu() {
    this.menu.classList.remove('ATCBarSelect__Menu--hidden');
  }

  closeMenu() {
    this.menu.classList.add('ATCBarSelect__Menu--hidden');
  }

  toggleMenu() {
    if (this.menu.classList.contains('ATCBarSelect__Menu--hidden')) {
      this.openMenu();
    } else {
      this.closeMenu();
    }
  }

  /**
   * Sync the price labels of all the size buttons to the current selected product.
   * This is only for when the hybrid foam upsell is selected, which means an
   * entirely new product was chosen to be added to cart.
   */
   syncPriceLabelsToState() {
    const productJSON = window.NolahPDPState.productJSON;
    const sizeKey = window.NolahPDPState.getOptionKey('Size');

    // Go through each size button and update its price labels
    this.sizeBtns.forEach(btn => {
      const size = btn.dataset.value;
      const foundVar = productJSON.variants.find(v => v[sizeKey] === size);
      const priceTag = btn.querySelector('.ATCBarSelect__PriceTag');
      let lowerPrice, higherPrice;

      // Be wary of multiplying the Twin XL price by two for Split King
      if (!foundVar && size === 'Split King') {
        const twinXLVar = productJSON.variants.find(
          v => v[sizeKey] === 'Twin XL'
        );
        lowerPrice = window.NUtils.formatMoney(
          window.NUtils.getVariantPrice(twinXLVar, false) * 2
        );
        higherPrice = window.NUtils.formatMoney(
          window.NUtils.getVariantStrikePrice(twinXLVar, false) * 2
        );
      } else {
        lowerPrice = window.NUtils.getVariantPrice(foundVar, true);
        higherPrice = window.NUtils.getVariantStrikePrice(foundVar, true);
      }

      priceTag.innerHTML = `<span class="StrikeLabel">${higherPrice}</span><b>${lowerPrice}</b>`;
    });

    // Update the selector's price label
    const currentPriceTag = this.selector.querySelector(
      '.ATCBarSelect__PriceTag'
    );
    const currentVar = window.NolahPDPState.currentVariant;
    const lowerPrice = window.NUtils.formatMoney(
      window.NolahPDPState.getPrice(currentVar)
    );
    const higherPrice = window.NUtils.formatMoney(
      window.NolahPDPState.getComparePrice(currentVar)
    );
    currentPriceTag.innerHTML = `<span class="StrikeLabel">${higherPrice}</span><b>${lowerPrice}</b>`;
  }

  logErrorWithContext(message) {
    const path = window.DUtils.getPathTo(this);
    const position = window.DUtils.getPageXY(this);
    console.error(message, {
      iCount: window.StickyATCBarSelectDebugObj.iCount,
      isConnected: this.isConnected,
      path,
      position,
    });
  }
}
customElements.define('sticky-atc-bar-select', StickyATCBarSelect);

window.MobileATCBarWrapperDebugObj = {
  iCount: 0,
};
class MobileATCBarWrapper extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;

    // Debug info
    window.MobileATCBarWrapperDebugObj.iCount++;
    this.instanceIndex = window.MobileATCBarWrapperDebugObj.iCount;
    if (this.instanceIndex === 2) {
      console.warn('mobile-atc-bar-wrapper: constructor called more than once');
    }
  }

  connectedCallback() {
    if (this.isConnected) {
      this.cacheElements();
    }

    if (this.isConnected && !this.initialized) {
      this.initialized = true;
      this.syncToCurrentVariant();
      this.attachListeners();
    }
  }

  disconnectedCallback() {
    if (!this.isConnected && this.initialized) {
      this.initialized = false;
      this.detachListeners();
    }
  }
  
  cacheElements() {
    this.menuClickHandler = this.menuClickHandler.bind(this);
    this.syncToCurrentVariant = this.syncToCurrentVariant.bind(this);

    this.selector = this.querySelector('.MABarSelect__Selector');
    this.menu = this.querySelector('.MABarSelectMenu');
    this.sizeBtns = this.querySelectorAll('.MABarSelectMenu__OptionBtn');
    this.zopimElements = [];
    this.sizeLabel = this.querySelector('.MABarSelect__Size');
    this.strikeLabel = this.querySelector('.MABarSelect__StrikeLabel');
    this.priceLabel = this.querySelector('.MABarSelect__Price');
  }

  attachListeners() {
    document.addEventListener('click', this.menuClickHandler);
    document.addEventListener('state:option-changed', this.syncToCurrentVariant);
  }

  detachListeners() {
    document.removeEventListener('click', this.menuClickHandler);
    document.removeEventListener('state:option-changed', this.syncToCurrentVariant);
  }

  /**
   * Sync to the current selected variant. Split king is a special 'fake' size
   * that is internally selected as the Twin XL mattress in NolahPDPState, but
   * with a flag pseudoSplitKingSelected set to true so we can know to add two
   * Twin XL mattresses when needed.
   */
  syncToCurrentVariant(e) {
    console.debug('mobile-atc-bar-wrapper: syncToCurrentVariant', this.isConnected, this.instanceIndex);
    const currentSize = window.NolahPDPState.getOptionByName('Size');

    // Escape quotations for querySelector strings with //"
    const escapedValue = currentSize.replace('"', '\\"');

    const selectedBtn =
      this.querySelector(`.MABarSelectMenu__OptionBtn[data-value="${escapedValue}"]`);
    this.updateSelfPassively(selectedBtn);

    // If the product JSON changed, we will want to update the price labels
    // in the size select.
    if (typeof e !== 'undefined' && e.detail && e.detail.productJSONChanged) {
      this.syncPriceLabelsToState();
    }
  }

  /**
   * Responsible for opening/closing the menu and selecting sizes
   */
  menuClickHandler(e) {
    if (e.target.matches('.MABarSelect__Selector')) {
      this.toggleMenu();
    } else if(e.target.matches('.MABarSelectMenu__OptionBtn')) {
      this.select(e.target);
    } else {
      this.closeMenu();
    }
  }

  /**
   * Updates the selected button, and changes the global state object,
   * triggering the state:option-changed event.
   */
  select(button) {
    // Set new selected button
    this.updateSelfPassively(button);

    // Clear any addons (since a new size was selected)
    window.NolahPDPState.clearAddons();

    // Update state and selector
    window.NolahPDPState.setSizeAndResetFirmness(button.dataset.value);

    this.closeMenu();
  }

  /**
   * Does not update state, and as a result, also does not trigger
   * the state:option-changed event. Meant to be used to update its select
   * passively in response to the variant changing due to other components.
   */
  updateSelfPassively(button) {
    if (!button) {
      this.logErrorWithContext('mobile-atc-bar-wrapper: updateSelfPassively without arg');
      return;
    }

    // Set new selected button
    this.sizeBtns.forEach(b => b.classList.remove('MABarSelectMenu__OptionBtn--selected'))
    button.classList.add('MABarSelectMenu__OptionBtn--selected');

    // Update selector
    const size = button.dataset.value;
    const strikeLabel = button.querySelector('.StrikeLabel').innerHTML;
    const priceLabel = button.querySelector('.MABarSelectMenu__Price').innerHTML;
    this.updateSelector(size, strikeLabel, priceLabel);
  }

  updateSelector(size, strikeLabel, priceLabel) {
    this.sizeLabel.innerHTML = size;
    this.strikeLabel.innerHTML = strikeLabel
    this.priceLabel.innerHTML = priceLabel;
  }

  hideChatBtns() {
    if (this.zopimElements.length <= 0) {
      this.zopimElements = document.querySelectorAll('.zopim[data-test-id]');
    }
    this.zopimElements.forEach(el => el.classList.add('zopim--hiddenOnMobile'));
  }

  showChatBtns() {
    if (this.zopimElements.length <= 0) {
      this.zopimElements = document.querySelectorAll('.zopim[data-test-id]');
    }
    this.zopimElements.forEach(el => el.classList.remove('zopim--hiddenOnMobile'));
  }

  openMenu() {
    this.menu.classList.remove('MABarSelectMenu--hidden');
    this.hideChatBtns();

    // Lift the floating chat and referral widgets above the open menu.
    document.documentElement.style.setProperty(
      '--mobile-atc-menu-height',
      `${this.menu.offsetHeight}px`
    );

    // The referral banner already sits above the sticky bar, so it only needs
    // to move up by the part of the menu it doesn't already clear.
    const talkable = document.querySelector('iframe[name="talkable-offer-iframe"]');
    if (talkable) {
      document.body.classList.remove('mobile-atc-menu-open');
      const gap = window.innerHeight - talkable.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty(
        '--mobile-atc-talkable-lift',
        `${Math.max(0, this.menu.offsetHeight - gap)}px`
      );
    }
    document.body.classList.add('mobile-atc-menu-open');
  }

  closeMenu() {
    this.menu.classList.add('MABarSelectMenu--hidden');
    this.showChatBtns();
    document.body.classList.remove('mobile-atc-menu-open');
  }

  toggleMenu() {
    if (this.menu.classList.contains('MABarSelectMenu--hidden')) {
      this.openMenu();
    } else {
      this.closeMenu();
    }
  }

  /**
   * Sync the price labels of all the size buttons to the current selected product.
   * This is only for when the hybrid foam upsell is selected, which means an
   * entirely new product was chosen to be added to cart.
   */
  syncPriceLabelsToState() {
    const productJSON = window.NolahPDPState.productJSON;
    const sizeKey = window.NolahPDPState.getOptionKey('Size');

    // Go through each size button and update its price labels
    this.sizeBtns.forEach(btn => {
      const size = btn.dataset.value;
      const foundVar = productJSON.variants.find(v => v[sizeKey] === size);
      const priceTag = btn.querySelector('.MABarSelectMenu__PriceTag');
      let lowerPrice, higherPrice;

      // Be wary of multiplying the Twin XL price by two for Split King
      if (!foundVar && size === 'Split King') {
        const twinXLVar = productJSON.variants.find(
          v => v[sizeKey] === 'Twin XL'
        );
        lowerPrice = window.NUtils.formatMoney(
          window.NUtils.getVariantPrice(twinXLVar, false) * 2
        );
        higherPrice = window.NUtils.formatMoney(
          window.NUtils.getVariantStrikePrice(twinXLVar, false) * 2
        );
      } else {
        lowerPrice = window.NUtils.getVariantPrice(foundVar, true);
        higherPrice = window.NUtils.getVariantStrikePrice(foundVar, true);
      }

      priceTag.innerHTML = `<span class="MABarSelectMenu__StrikeLabel StrikeLabel">${higherPrice}</span><b class="MABarSelectMenu__Price">${lowerPrice}</b>`;
    });

    // Update the selector's price label
    const currentVar = window.NolahPDPState.currentVariant;
    const lowerPrice = window.NUtils.formatMoney(
      window.NolahPDPState.getPrice(currentVar)
    );
    const higherPrice = window.NUtils.formatMoney(
      window.NolahPDPState.getComparePrice(currentVar)
    );
    this.strikeLabel.innerHTML = higherPrice;
    this.priceLabel.innerHTML = lowerPrice;
  }

  logErrorWithContext(message) {
    const path = window.DUtils.getPathTo(this);
    const position = window.DUtils.getPageXY(this);
    console.error(message, {
      iCount: window.MobileATCBarWrapperDebugObj.iCount,
      isConnected: this.isConnected,
      path,
      position,
    });
  }
}
customElements.define('mobile-atc-bar-wrapper', MobileATCBarWrapper);
